export const DEFAULT_GIFT_EXPIRY_DAYS = 30

export const giftType = {
  PRODUCT: 'Product',
  DISCOUNT_CODE: 'Discount Code',
  BOUNTY_AD_HOC: 'Bounty',
} as const
